module.exports = __webpack_public_path__ + "media/stylesheets/images/writer1-8da843ddac0bbd6a04512eae193380ae.jpg";